module.exports = __webpack_public_path__ + "static/physics-863d82dca55005f32880b0c943121be5.jpg";